import { Button } from 'antd';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { handleAuthStatus } from '@src/utils/utils';

//width: ${width || '100%'} ;
const CustomButtons = styled(Button)(
  ({ height, width }) => ` 
  height: ${height || '58'}px;
  border-radius: 4px;
  font-family: UbuntuMedium, sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
`,
);
//color: #fff;

const CustomButton = (props) => {
  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const { buttonAuthName = '', ...restProps } = props;
  return !handleAuthStatus(userAuthorizationStatus, buttonAuthName) && <CustomButtons {...restProps} />;
};

export default CustomButton;
